import React from 'react';

const TwitterIcon = (): JSX.Element => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M13.976,10.162L22.718,0h-2.072l-7.591,8.824L6.993,0H0l9.168,13.343L0,24h2.072l8.016-9.318,6.403,9.318h6.993l-9.508-13.838h0Z" />
  </svg>
);

export default TwitterIcon;
